import React from 'react';
import measurementsIcon from '#component/icon/measurements';
import { Card, StyledCardContent, CardIdentifiers } from '#component/shipment/overview/components/mobile-view/styles';

export const ShipmentInfoCard = props => {
  const {
    handleOpen
  } = props;

  const icon = measurementsIcon('info');
  const INFO_TAB = 120;

  return (
    <Card>
      <StyledCardContent
        onClick={() => handleOpen(INFO_TAB)}
      >
        <CardIdentifiers>
          {icon}
          INFO
        </CardIdentifiers>
      </StyledCardContent>
    </Card>
  );
};
